(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/bingo-react/assets/javascripts/router.js') >= 0) return;  svs.modules.push('/modules/bingo-react/assets/javascripts/router.js');
'use strict';

const _ReactRouterDOM = ReactRouterDOM,
  Router = _ReactRouterDOM.BrowserRouter,
  Route = _ReactRouterDOM.Route,
  Switch = _ReactRouterDOM.Switch;
const _svs$components$lbUti = svs.components.lbUtils.setMetaTags,
  setMetaTags = _svs$components$lbUti.setMetaTags,
  setHeaderImageAltText = _svs$components$lbUti.setHeaderImageAltText;
const CampaignFlerp = svs.components.lbUi.campaignFlerp.CampaignFlerp;
const _svs$bingo_react = svs.bingo_react,
  _svs$bingo_react$page = _svs$bingo_react.pages,
  BingoLobby = _svs$bingo_react$page.BingoLobby,
  BingoArticles = _svs$bingo_react$page.BingoArticles,
  BingoSchool = _svs$bingo_react$page.BingoSchool,
  BingoChatSchedule = _svs$bingo_react$page.BingoChatSchedule,
  WidgetPage = _svs$bingo_react$page.WidgetPage,
  BingoNavMenu = _svs$bingo_react.components.nav_menu.BingoNavMenu;
const MenuTabTypes = svs.bingo_react.components.common.constants.MenuTabTypes;
const getPageComponent = tabType => {
  switch (tabType) {
    case MenuTabTypes.BingoLobby:
      return BingoLobby;
    case MenuTabTypes.BingoArticles:
      return BingoArticles;
    case MenuTabTypes.BingoSchool:
      return BingoSchool;
    case MenuTabTypes.BingoChatSchedule:
      return BingoChatSchedule;
    default:
      return WidgetPage;
  }
};
const BingoRouter = () => {
  const routes = svs.bingo_react.data.tabsConfig;
  const activeRoutes = routes.filter(route => route.active);
  const lobbyRoute = routes.find(route => route.path === '' && route.tabType === 'lobby');
  return React.createElement(Router, {
    basename: svs.core.data.baseUrl
  }, React.createElement(CampaignFlerp, null), React.createElement(BingoNavMenu, {
    routes: activeRoutes
  }), React.createElement(Switch, null, React.createElement(Route, {
    exact: true,
    path: "/",
    render: () => {
      setHeaderImageAltText((lobbyRoute === null || lobbyRoute === void 0 ? void 0 : lobbyRoute.logotypeAltText) || "Bingo - ".concat(lobbyRoute === null || lobbyRoute === void 0 ? void 0 : lobbyRoute.label));
      setMetaTags({
        docTitle: (lobbyRoute === null || lobbyRoute === void 0 ? void 0 : lobbyRoute.metaTitle) || "Bingo - ".concat(lobbyRoute === null || lobbyRoute === void 0 ? void 0 : lobbyRoute.label),
        metaDesc: (lobbyRoute === null || lobbyRoute === void 0 ? void 0 : lobbyRoute.metaDescription) || "Bingo - ".concat(lobbyRoute === null || lobbyRoute === void 0 ? void 0 : lobbyRoute.label)
      });
      return React.createElement(BingoLobby, {
        headerConfig: lobbyRoute.headerConfig,
        widgetAreaIndex: lobbyRoute.widgetArea
      });
    }
  }), activeRoutes.map(route => React.createElement(Route, {
    exact: route.path === '',
    key: route.path,
    path: "/".concat(route.path),
    render: () => {
      const Component = getPageComponent(route.tabType);
      setHeaderImageAltText((route === null || route === void 0 ? void 0 : route.logotypeAltText) || "Bingo - ".concat(route === null || route === void 0 ? void 0 : route.label));
      setMetaTags({
        docTitle: (route === null || route === void 0 ? void 0 : route.metaTitle) || "Bingo - ".concat(route === null || route === void 0 ? void 0 : route.label),
        metaDesc: (route === null || route === void 0 ? void 0 : route.metaDescription) || "Bingo - ".concat(route === null || route === void 0 ? void 0 : route.label)
      });
      return React.createElement(Component, {
        headerConfig: route.headerConfig,
        widgetAreaIndex: route.widgetArea
      });
    }
  }))));
};
setGlobal('svs.bingo_react.BingoRouter', BingoRouter);

 })(window);